<template>
  <div>
    <label v-for="navMenus in navMenu">
      <el-menu-item v-if="navMenus.columnType == '1'"
                    :index="navMenus.columnId+''"
                    :class="navMenus.parentId == '0' ? '' : 'sonMenu'"
                    route="false"
                    @click.native.stop="handleIndex(navMenus.columnId)" >
        <i :class="navMenus.icon"></i>
        <span
            slot="title"
            style="word-break: break-all;!important  word-wrap: break-word;!important"
            :title="navMenus.columnName">
          {{navMenus.columnName}}
        </span>
      </el-menu-item>
      <div>
        <el-submenu v-if="navMenus.columnType == '0'"
                    :key="navMenus.columnId+''"
                    :index="navMenus.columnId+''">
          <template slot="title">
            <i :class="navMenus.icon"></i>
            <span
                style="word-break: break-all;!important  word-wrap: break-word; !important"
                :title="navMenus.columnName">
              {{navMenus.columnName}}
            </span>
          </template>
          <document-center-left :navMenu="navMenus.children" style=""/>
        </el-submenu>
      </div>
    </label>
  </div>
</template>

<script>

import DocumentCenterBody from "./document-center-body.vue";
import { Bus } from '../js/bus.js'

export default {

  name: "document-center-left",

  components: {
    DocumentCenterBody,
  },

  props: {
    navMenu:[]
  },

  data() {
    return {
    }
  },

  created() {

  },

  mounted() {
  },

  updated() {
  },

  methods: {
    handleSelect(key, keyPath){
    },
    handleIndex(columnId){
      Bus.$emit('docCenterCmsGetByColumnId',columnId)
    },
  }
}
</script>

<style lang="scss" scoped>

.el-submenu {
  font-weight: 550;
}
.el-submenu span {
}
.el-submenu__title {
}
.el-submenu__title span{
  display:block;
  width:90%;
  overflow:hidden;
  white-space:nowrap;
  text-overflow:ellipsis;
}

.el-menu-item {
  font-weight: 550;
}
.el-menu-item span {
}
.el-menu-item__title{
}
.el-menu-item__title span{
  display:block;
  width:90%;
  overflow:hidden;
  white-space:nowrap;
  text-overflow:ellipsis;
}

</style>
